import React, { Fragment, useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Container,
  Form,
  FormGroup,
  Label,
  Button,
  Card,
  CardBody,
  Input,
  Row,
  Col,
} from "reactstrap";
import Breadcrumbs from "../../Components/Common/Breadcrumb";
import { customOptionsStyle } from "../../Constant";
import Select from "react-select";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file
import JobPipelineDatatable from "../../Components/Recruiter/JobPipeline/JobPipelineDatatable";
import { fetchJobPipelineRequest } from "../../redux/recruiter/job_pipeline/actions";
import { fetchJobNamesRequest } from "../../redux/recruiter/job_name/actions";
import { statusOptions } from "../../Constant";
import { FaCalendarAlt } from "react-icons/fa"; // FontAwesome calendar icon
const JobPipelinePage = () => {
  const dispatch = useDispatch();

  const today = new Date();
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

  const [formData, setFormData] = useState({
    jobId: null,
    candidateStatus: "",
    dateRange: {
      startDate: oneMonthAgo,
      endDate: today,
    },
  });
  const [errors, setErrors] = useState({});
  const [datePickerOpen, setDatePickerOpen] = useState(false);

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
    const formateData = {
      job_id: formData.jobId,
      startDate: formData.dateRange.startDate.toISOString(),
      endDate: formData.dateRange.endDate.toISOString(),
      candidate_status: formData.candidateStatus,
    };
    dispatch(fetchJobPipelineRequest(formateData));
  }, []);

  const jobPipelineReducerData = useSelector(
    (state) => state.jobPipelineReducer
  );
  const jobPipelineData = jobPipelineReducerData.data;

  const handleDateRangeChange = (ranges) => {
    if (ranges.range1 && ranges.range1.startDate && ranges.range1.endDate) {
      setFormData({
        ...formData,
        dateRange: {
          startDate: ranges.range1.startDate,
          endDate: ranges.range1.endDate,
        },
      });
      setErrors({
        ...errors,
        dateRange: "",
      });
      setDatePickerOpen(false);
    } else {
      console.error("Invalid date range selection:", ranges);
    }
  };

  const formatDate = (date) => {
    return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = {};

    if (!formData.dateRange.startDate || !formData.dateRange.endDate) {
      newErrors.dateRange = "Please select a date range";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const allStatusOption = { value: "", label: "All" };
  const candidateStatusOptions = [allStatusOption, ...statusOptions];

  const handleCandidateStatusChange = (selectedOption) => {
    setFormData({
      ...formData,
      candidateStatus: selectedOption ? selectedOption.value : "",
    });
    setErrors({
      ...errors,
      candidateStatus: "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      const formateData = {
        job_id: formData.jobId,
        startDate: formData.dateRange.startDate.toISOString(),
        endDate: formData.dateRange.endDate.toISOString(),
        candidate_status: formData.candidateStatus,
      };
      dispatch(fetchJobPipelineRequest(formateData));
    } else {
      console.error("Form validation failed");
    }
  };

  const locale = {
    localize: {
      month: (monthIndex) => {
        const months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        return months[monthIndex];
      },
      day: (dayIndex) => {
        const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        return days[dayIndex];
      },
    },
    formatLong: {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    },
  };

  const [jobNameOptions, setJobNameOptions] = useState([]);

  let jobNameReducerData = useSelector((state) => state.jobNameReducer);
  let jobNameData = jobNameReducerData.data.data;
  console.log("jobNameData", jobNameData);

  useEffect(() => {
    if (jobNameData && jobNameData.length > 0) {
      const allOption = { id: null, value: '', label: 'All' };
      setJobNameOptions([allOption, ...jobNameData]);
    } else {
      setJobNameOptions([]);
    }
  }, [jobNameData]);

  const handleJobNameFocus = () => {
    const fetchData = async () => {
      try {
        const keyword = "";
        dispatch(fetchJobNamesRequest(keyword));
      } catch (error) { }
    };
    fetchData();
  };

  const handleJobNameInputChange = useCallback((inputValue) => {
    const fetchData = async () => {
      try {
        dispatch(fetchJobNamesRequest(inputValue));
      } catch (error) { }
    };
    fetchData();
  }, []);

  const handleJobNameChange = (selectedOptions) => {
    const updatedErrors = { ...errors, jobId: "" };
    setErrors(updatedErrors);
    setFormData({
      ...formData,
      jobId: selectedOptions ? selectedOptions.value : null,
    });
  };

  return (
    <Fragment>
      <Breadcrumbs title="Job Pipeline" mainTitle="Job Pipeline" />
      <Container fluid>
        <Form className="theme-form" onSubmit={handleSubmit}>
          <Card>
            <CardBody>
              <div className="row gx-3">
                <div className="col-12 col-md-6 col-lg-4 mb-3">
                  <FormGroup className="mb-0">
                    <Label>Job Name</Label>
                    <Select
                      isLoading={jobNameReducerData.isLoading}
                      options={jobNameOptions}
                      value={jobNameOptions.find(
                        (opt) => opt.id === formData.jobId
                      )}
                      onChange={handleJobNameChange}
                      styles={customOptionsStyle}
                      onFocus={handleJobNameFocus}
                      onInputChange={handleJobNameInputChange}
                      placeholder="Select job name..."
                    />
                  </FormGroup>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-3">
                  <FormGroup className="mb-0">
                    <Label>Job Candidate Status</Label>
                    <Select
                      styles={customOptionsStyle}
                      options={candidateStatusOptions}
                      value={candidateStatusOptions.find(
                        (opt) => opt.value === formData.candidateStatus
                      )}
                      onChange={handleCandidateStatusChange}
                      placeholder="Select candidate status..."
                    />
                  </FormGroup>
                </div>
                <div className="col-12 col-lg-5 d-flex align-items-center mb-3">
                  <div className="flex-grow-1 d-flex align-items-center me-2">
                    <FormGroup className="mb-0 flex-grow-1">
                      <Label>
                        Date
                        <span className="text-danger">*</span>
                      </Label>
                      <Button
                        color="primary"
                        id="shownCalendar"
                        onClick={() => setDatePickerOpen(!datePickerOpen)}
                        className="d-flex align-items-center px-3 flex-grow-1"
                        style={{ height: "38px" }}
                      >
                        <FaCalendarAlt />
                        <span className="ms-2">
                          {`${formatDate(
                            formData.dateRange.startDate
                          )} - ${formatDate(formData.dateRange.endDate)}`}
                        </span>
                      </Button>
                    </FormGroup>
                  </div>
                  <Button
                    color="primary"
                    type="submit"
                    className="flex-grow-1"
                    style={{ height: "38px" }}
                    disabled={jobPipelineReducerData.isLoading}
                  >
                    Apply
                  </Button>
                </div>
              </div>

              {datePickerOpen && (
                <div className="mt-3">
                  <DateRangePicker
                    editableDateInputs
                    onChange={handleDateRangeChange}
                    ranges={[formData.dateRange]}
                    locale={locale}
                    months={2}
                    direction="horizontal"
                    open={datePickerOpen}
                    onToggle={(open) => setDatePickerOpen(open)}
                  />
                </div>
              )}
              <JobPipelineDatatable
                jobPipelineData={jobPipelineData}
                formData={formData}
              />
            </CardBody>
          </Card>
        </Form>
      </Container>
    </Fragment>
  );
};

export default JobPipelinePage;
